"use client";

import PWAInstallPrompt from "./PWAInstallPrompt";
import PWAOfflineIndicator from "./PWAOfflineIndicator";
import PWAUpdateNotification from "./PWAUpdateNotification";

export default function PWAComponents() {
  return (
    <>
      <PWAOfflineIndicator />
      <PWAInstallPrompt />
      <PWAUpdateNotification />
    </>
  );
}
